class AreaInput extends HTMLElement {
  quantityUpdateUnsubscriber = undefined;

  constructor() {
    super();
  }

  get sectionId() {
    return this.getAttribute("data-section-id");
  }

  get productId() {
    return this.getAttribute("data-product-id");
  }

  get input() {
    return this.querySelector("input");
  }

  get value() {
    return this.input.value;
  }

  connectedCallback() {
    this.changeEvent = new Event("change", { bubbles: true });
    // this.input.addEventListener("input", this.onInputChange.bind(this));
    this.input.addEventListener("focus", () =>
      setTimeout(() => this.input.select())
    );
  }

  disconnectedCallback() {}
}
customElements.define("area-input", AreaInput);

class TilesCalculator extends HTMLElement {
  currentQty;
  add10PercentWastage = false;
  constructor() {
    super();
    this.currentQty = 1;
  }
  get sectionId() {
    return this.getAttribute("data-section-id");
  }
  get productId() {
    return this.getAttribute("data-product-id");
  }
  get areaInput() {
    return this.querySelector(`#AreaForm-${this.sectionId} area-input input`);
  }
  get boxInput() {
    return this.querySelector(
      `#QuantityForm-${this.sectionId} quantity-input input`
    );
  }
  get wastageCheckbox() {
    return this.querySelector("input[type='checkbox'][name='wastage']");
  }
  get selectedVariantId() {
    return this.getAttribute("data-variant-id");
  }
  get baseM2() {
    return this.getAttribute("data-base-m2");
  }
  get productFormId() {
    return this.getAttribute("data-product-form-id");
  }
  connectedCallback() {
    this.changeEvent = new Event("change", { bubbles: true });
    if (this.boxInput) {
      this.boxInput.addEventListener("input", this.onBoxInputChange.bind(this));
    }
    if (this.areaInput) {
      this.areaInput.addEventListener(
        "input",
        this.onAreaInputChange.bind(this)
      );
    }
    if (this.wastageCheckbox) {
      this.wastageCheckbox.addEventListener(
        "change",
        this.onWastageCheckboxChange.bind(this)
      );
    }
    this.productFrom = document.querySelector(`form#${this.productFormId}`);
    this.productFromQuantity = document.querySelector(
      `form#${this.productFormId} input[name="quantity"]`
    );
    this.mainProductInfo = document.querySelector(
      `product-info[data-product-id="${this.productId}"]`
    );
    this.mainProductForm =
      this.mainProductInfo?.querySelector(".main-product-form");

    this.cartUpdateUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.cartUpdate,
      this.resetInputValues.bind(this)
    );
    this.variantChangeUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange,
      this.onVariantChange.bind(this)
    );
    this.optionValueSelectionChangeUnsubscriber = FoxTheme.pubsub.subscribe(
      FoxTheme.pubsub.PUB_SUB_EVENTS.optionValueSelectionChange,
      this.onOptionValueSelectionChange.bind(this)
    );
    this.variantData = this.getVariantData();
    this.currentVariant = this.variantData.find(
      (variant) => variant.id === Number(this.selectedVariantId)
    );
    this.updateButtonText(this.getButtonText());
  }
  disconnectedCallback() {
    if (this.boxInputElement) {
      this.boxInputElement.removeEventListener(
        "input",
        this.onBoxInputElementChange.bind(this)
      );
    }
    if (this.areaInputElement) {
      this.areaInputElement.removeEventListener(
        "input",
        this.onAreaInputElementChange.bind(this)
      );
    }
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }
    if (this.variantChangeUnsubscriber) {
      this.variantChangeUnsubscriber();
    }
    if (this.optionValueSelectionChangeUnsubscriber) {
      this.optionValueSelectionChangeUnsubscriber();
    }
  }
  resetInputValues() {
    this.setAttribute("data-base-m2", this.currentVariant.baseM2 || this.baseM2 || 0.00);
    this.areaInput.value = Number(this.currentVariant.baseM2) || this.areaInput.min || 0.0;
    this.boxInput.value = this.boxInput.min || 1;
    this.currentQty = 1;
    this.add10PercentWastage = false;
    this.wastageCheckbox.checked = false;
    this.publishQuantityChange();
    this.updateProductFormQuantity();
  }
  onOptionValueSelectionChange(){
    this.resetInputValues();
  }
  onBoxInputChange(event) {
    let quantity = parseFloat(event.target.value);
    if (isNaN(quantity) || quantity < 1) {
      this.currentQty = 1;
    } else {
      this.currentQty = quantity;
    }
    this.wastageCheckbox.checked = false;
    this.add10PercentWastage = false;
    this.syncInputs("box");
    this.updateProductFormQuantity();
    this.publishQuantityChange();
  }
  onAreaInputChange(event) {
    let area = parseFloat(event.target.value);
    if (isNaN(area) || area <= this.baseM2) area = this.baseM2;
    this.currentQty = Math.max(1, Math.ceil(area / parseFloat(this.baseM2)));
    this.syncInputs("area");
    this.updateProductFormQuantity();
    this.publishQuantityChange();
  }
  publishQuantityChange() {
    FoxTheme.pubsub.publish("tilesQuantityInput:changed", {
      data: {
        sectionId: this.sectionId,
        productId: this.productId,
        quantity: this.getFinalQuantity(),
        baseM2: this.baseM2,
      },
    });
  }
  syncInputs(type) {
    switch (type) {
      case "box":
        if (this.areaInput) {
          const area = parseFloat(this.baseM2) * this.currentQty;
          this.areaInput.value = area.toFixed(2);
        }
        break;
      case "area":
        if (this.boxInput) {
          this.boxInput.value = this.currentQty;
        }
      default:
        break;
    }
  }
  onWastageCheckboxChange(event) {
    this.add10PercentWastage = event.target.checked;
    this.boxInput.value = this.getFinalQuantity();
    this.areaInput.value = parseFloat(
      this.getFinalQuantity() * this.baseM2
    ).toFixed(2);
    this.updateProductFormQuantity();
    this.publishQuantityChange();
  }
  getVariantData() {
    const { variants, variantsMetafields } = JSON.parse(
      this.querySelector('[type="application/json"]').textContent
    );
    this.variantData = variants.map((variant) => {
      const metafields = variantsMetafields.find(
        (item) => item.id === variant.id
      );
      return {
        ...variant,
        price: metafields?.pricePerSqm || variant.price,
        compare_at_price: metafields?.wasPricePerSqm || variant.price,
        original_price: variant.price,
        original_compare_at_price: variant.compare_at_price,
        baseM2: metafields?.baseM2 || null,
      };
    });
    return this.variantData;
  }
  onVariantChange(event) {
    const isMainProduct =
      event.data.sectionId === this.mainProductInfo.dataset.section;
    if (!isMainProduct) return;
    const variant = event.data.variant;
    this.currentVariant = variant;
    this.resetInputValues();
    this.updateProductFormQuantity();
  }
  getFinalQuantity() {
    let boxRequired = this.currentQty;
    let finalarea = this.baseM2 * boxRequired;
    if (this.add10PercentWastage) {
      finalarea *= 1.1;
      boxRequired = Math.ceil(finalarea / this.baseM2);
    }
    return boxRequired;
  }
  updateProductFormQuantity() {
    if (!this.productFromQuantity) return;
    this.productFromQuantity.value = this.getFinalQuantity();
    if (this.mainProductForm) {
      const quantityInput = this.mainProductForm.querySelector(
        'input[name="quantity"]'
      );
      if (quantityInput) {
        quantityInput.value = this.getFinalQuantity();
      }
    }
    this.updateButtonText(this.getButtonText(this.getFinalQuantity()));
  }
  updateButtonText(text) {
    if (!this.mainProductForm) return;
    const addButton = this.mainProductForm.querySelector('[name="add"]');
    if (!addButton) return;

    const addButtonText = addButton.querySelector("span");
    addButtonText.textContent = text ? text : FoxTheme.variantStrings.addToCart;
  }
  getButtonText(boxRequired = 1) {
    if (!this.currentVariant) {
      const curreentVariantId = this.getAttribute("data-variant-id");
      this.currentVariant = this.variantData.find(
        (variant) => variant.id === Number(curreentVariantId)
      );
    }
    if (!this.currentVariant) {
      this.currentVariant = this.variantData[0];
    }
    if (!this.currentVariant) return "";
    if (this.currentVariant) {
      if (this.currentVariant.baseM2) {
        const price = this.currentVariant.original_price * boxRequired;
        return `Add ${boxRequired} box${
          boxRequired > 1 ? "es" : ""
        } - ${FoxTheme.Currency.formatMoney(
          price,
          FoxTheme.settings.moneyFormat
        )}`;
      } else {
        return FoxTheme.variantStrings.addToCart;
      }
    } else {
      return FoxTheme.variantStrings.soldOut;
    }
  }
}
customElements.define("tiles-calculator", TilesCalculator);

class TilesProductDetails extends HTMLElement {
  constructor() {
    super();
  }
  get sectionId() {
    return this.getAttribute("data-section-id");
  }

  get productId() {
    return this.getAttribute("data-product-id");
  }

  get boxQty() {
    return this.querySelector("[data-unit-qty]");
  }

  get area() {
    return this.querySelector("[data-unit-area]");
  }
  connectedCallback() {
    this.tilesQuantityInputChangeUnsubscriber = FoxTheme.pubsub.subscribe(
      "tilesQuantityInput:changed",
      this.onTilesQuantityInputChange.bind(this)
    );
  }
  disconnectedCallback() {
    if (this.tilesQuantityInputChangeUnsubscriber) {
      this.tilesQuantityInputChangeUnsubscriber();
    }
  }
  onTilesQuantityInputChange(event) {
    const { sectionId, productId, quantity, baseM2 } = event.data;
    if (productId != this.productId) return;
    if (quantity && baseM2 && this.area && this.boxQty) {
      let boxRequired = quantity;
      let finalarea = baseM2 * boxRequired;
      this.boxQty.textContent = boxRequired;
      this.area.textContent = finalarea.toFixed(2);
    }
  }
}
customElements.define("tiles-product-details", TilesProductDetails);
